"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SidebarType = void 0;
/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  
  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.                                                                              *
 ******************************************************************************************************************** */
const react_1 = __importStar(require("react"));
const Drawer_1 = __importDefault(require("@material-ui/core/Drawer"));
const styles_1 = require("@material-ui/core/styles");
const Close_1 = __importDefault(require("@material-ui/icons/Close"));
const IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
const useStyles = styles_1.makeStyles((theme) => ({
    drawer: {
        height: '100%',
        flexShrink: 0,
        width: (props) => props.sidebarWidth,
    },
    drawerPaper: {
        [theme.breakpoints.up('sm')]: {
            height: '100%',
            position: 'relative',
            width: (props) => props.sidebarWidth,
        },
        [theme.breakpoints.down('xs')]: {
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            width: '100%',
            zIndex: theme.zIndex.modal + 10,
        },
    },
    closeDrawer: {
        position: 'absolute',
        right: '20px',
        top: '15px',
        zIndex: 1,
        '& > button': {
            padding: 0,
        },
        '& > button > span': {
            padding: 0,
            display: 'inline',
            lineHeight: 1.5,
        },
    },
    sidebar: {
        display: 'flex',
        borderRadius: 0,
        backgroundColor: theme.palette.background.paper,
        borderRight: `1px solid ${theme.palette.grey['200']}`,
        minWidth: '50px',
    },
}));
var SidebarType;
(function (SidebarType) {
    SidebarType["SIDE_NAVIGATION"] = "SIDE_NAVIGATION";
    SidebarType["HELP_PANEL"] = "HELP_PANEL";
})(SidebarType = exports.SidebarType || (exports.SidebarType = {}));
const Sidebar = (props) => {
    const classes = useStyles(props);
    const isOpen = react_1.useMemo(() => {
        return props.isSidebarOpen === 'true';
    }, [props.isSidebarOpen]);
    const handleDrawerClose = () => {
        props.setIsSidebarOpen('false');
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        props.displayIcon &&
            props.type === SidebarType.SIDE_NAVIGATION &&
            !isOpen &&
            props.renderIcon(classes.sidebar),
        react_1.default.createElement(Drawer_1.default, { className: classes.drawer, variant: "persistent", anchor: props.type === SidebarType.SIDE_NAVIGATION ? 'left' : 'right', open: isOpen, classes: {
                paper: classes.drawerPaper,
            }, SlideProps: {
                timeout: 0,
            } },
            react_1.default.createElement("div", { className: classes.closeDrawer },
                react_1.default.createElement(IconButton_1.default, { onClick: handleDrawerClose },
                    react_1.default.createElement(Close_1.default, null))),
            props.children),
        props.displayIcon && props.type === SidebarType.HELP_PANEL && !isOpen && props.renderIcon(classes.sidebar)));
};
exports.default = Sidebar;
//# sourceMappingURL=index.js.map